/**
*
* @param {import("./formSchema.d.ts")} formSchema
*/
const formSchema = {
    "BRA": {
        "language": "pt-BR",
        "documentsList": [
            "CPF",
            "CNPJ"
        ],
        "b2bDocument": "CNPJ",
        "billingAddressList": [
            ["billing_address_postal_code"],
            ["billing_address_street1"],
            ["billing_address_number", "billing_address_district"],
            ["billing_address_city", "billing_address_state_br"],
            ["billing_address_complement"]
        ],
        "shippingAddressList": [
            ["shipping_address_postal_code"],
            ["shipping_address_street1"],
            ["shipping_address_number", "shipping_address_district"],
            ["shipping_address_city", "shipping_address_state_br"],
            ["shipping_address_complement"]
        ],
        "countryDial": 55,
        "defaultCountryOption": { value: "BRA", label: "Brasil" },
        "phoneMask": "+99 (99) 999999999"

    },
    "PER": {
        "language": "es-ES",
        "documentsList": [
            "DNI",
            "CE",
            "RUC",
        ],
        "b2bDocument": "RUC",
        "billingAddressList": [
            [
                "billing_address_street1"
            ],
            [
                "billing_address_city",
                "billing_address_state"
            ],
            ["billing_address_postal_code_no_mask"],
        ],
        "shippingAddressList": [
            [
                "shipping_address_street1"
            ],
            [
                "shipping_address_city",
                "shipping_address_state"
            ],
            [
                "shipping_address_postal_code_no_mask"
            ],
        ],
        "countryDial": 51,
        "defaultCountryOption": { value: "PER", label: "Peru" },
        "phoneMask": "+99 (999) 999-999"

    },
    "CHL": {
        "language": "es-ES",
        "documentsList": [
            "CI",
            "RUT",
        ],
        "b2bDocument": "RUT",
        "billingAddressList": [
            [
                "billing_address_street1"
            ],
            [
                "billing_address_city",
                "billing_address_state"
            ],
            [
                "billing_address_postal_code_no_mask"
            ],
        ],
        "shippingAddressList": [
            [
                "shipping_address_street1"
            ],
            [
                "shipping_address_city",
                "shipping_address_state"
            ],
            [
                "shipping_address_postal_code_no_mask"
            ],
        ],
        "countryDial": 56,
        "defaultCountryOption": { value: "CHL", label: "Chile" },
        "phoneMask": "+99-9-9999-9999"


    },
    "ARG": {
        "language": "es-ES",
        "documentsList": [
            "DNI",
            "CUIT"
        ],
        "b2bDocument": "CUIT",
        "billingAddressList": [
            [
                "billing_address_street1"
            ],
            [
                "billing_address_city",
                "billing_address_state"
            ],
            [
                "billing_address_postal_code_no_mask"
            ],
        ],
        "shippingAddressList": [
            [
                "shipping_address_street1"
            ],
            [
                "shipping_address_city",
                "shipping_address_state"
            ],
            [
                "shipping_address_postal_code_no_mask"
            ],
        ],
        "countryDial": 54,
        "defaultCountryOption": { value: "ARG", label: "Argentina" },
        "phoneMask": "+99 (999) 999-9999"


    },
    "COL": {
        "language": "es-ES",
        "documentsList": [
            "TI",
            "CI",
            "NIT"
        ],
        "b2bDocument": "NIT",
        "billingAddressList": [
            [
                "billing_address_street1"
            ],
            [
                "billing_address_city",
                "billing_address_state"
            ],
            [
                "billing_address_postal_code_no_mask"
            ],
        ],
        "shippingAddressList": [
            [
                "shipping_address_street1"
            ],
            [
                "shipping_address_city",
                "shipping_address_state"
            ],
            [
                "shipping_address_postal_code_no_mask"
            ],
        ],
        "countryDial": 57,
        "defaultCountryOption": { value: "COL", label: "Colombia" },
        "phoneMask": "+99 (999) 999-9999"
    },
    "FRA": {
        "language": "fr-FR",
        "documentsList": [
            "CNI",
            "SIRET",
        ],
        "b2bDocument": "SIRET",
        "billingAddressList": [
            ["billing_address_street1"],
            ["billing_address_street2"],
        ],
        "shippingAddressList": [

            [
                "shipping_address_street1"
            ],
            [
                "shipping_address_street2"
            ],

        ],
        "countryDial": 33,
        "defaultCountryOption": { value: "FRA", label: "France" },
        "phoneMask": "+99 (999) 999-999"

    },
    // "USA": {
    //     "language": "en",
    //     "documentsList": [],
    //     "b2bDocument": null,
    //     "billingAddressList": [
    //         ["billing_address_street1"],
    //         ["billing_address_city", "billing_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "shippingAddressList": [
    //         ["shipping_address_street1"],
    //         ["shipping_address_city", "shipping_address_state"],
    //         ["shipping_address_postal_code_no_mask"]
    //     ],
    //     "countryDial": 1,
    //     "defaultCountryOption": { value: "USA", label: "United States" },
    //     "phoneMask": "+9 (999) 999-9999"
    // },
    // "URY": {
    //     "language": "es-ES",
    //     "documentsList": [],
    //     "b2bDocument": null,
    //     "billingAddressList": [
    //         ["billing_address_street1"],
    //         ["billing_address_city", "billing_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "shippingAddressList": [
    //         ["shipping_address_street1"],
    //         ["shipping_address_city", "shipping_address_state"],
    //         ["shipping_address_postal_code_no_mask"]
    //     ],
    //     "countryDial": 598,
    //     "defaultCountryOption": { value: "URY", label: "Uruguay" },
    //     "phoneMask": "+999 9999-9999"
    // },
    // "PRY": {
    //     "language": "es-ES",
    //     "documentsList": [],
    //     "b2bDocument": null,
    //     "billingAddressList": [
    //         ["billing_address_street1"],
    //         ["billing_address_city", "billing_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "shippingAddressList": [
    //         ["shipping_address_street1"],
    //         ["shipping_address_city", "shipping_address_state"],
    //         ["shipping_address_postal_code_no_mask"]
    //     ],
    //     "countryDial": 595,
    //     "defaultCountryOption": { value: "PRY", label: "Paraguay" },
    //     "phoneMask": "+999 999-999999"
    // },
    // "BOL": {
    //     "language": "es-ES",
    //     "documentsList": [],
    //     "b2bDocument": null,
    //     "billingAddressList": [
    //         ["billing_address_street1"],
    //         ["billing_address_city", "billing_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "shippingAddressList": [
    //         ["shipping_address_street1"],
    //         ["shipping_address_city", "billing_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "countryDial": 591,
    //     "defaultCountryOption": { value: "BOL", label: "Bolivia" },
    //     "phoneMask": "+999 9-999-9999"
    // },
    // "VEN": {
    //     "language": "es-ES",
    //     "documentsList": [],
    //     "b2bDocument": null,
    //     "billingAddressList": [
    //         ["billing_address_street1"],
    //         ["billing_address_city", "billing_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "shippingAddressList": [
    //         ["shipping_address_street1"],
    //         ["shipping_address_city", "shipping_address_state"],
    //         ["shipping_address_postal_code_no_mask"]
    //     ],
    //     "countryDial": 58,
    //     "defaultCountryOption": { value: "VEN", label: "Venezuela" },
    //     "phoneMask": "+99 (999) 999-9999"
    // },
    // "ECU": {
    //     "language": "es-ES",
    //     "documentsList": [],
    //     "b2bDocument": null,
    //     "billingAddressList": [
    //         ["billing_address_street1"],
    //         ["billing_address_city", "billing_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "shippingAddressList": [
    //         ["shipping_address_street1"],
    //         ["shipping_address_city", "shipping_address_state"],
    //         ["shipping_address_postal_code_no_mask"]
    //     ],
    //     "countryDial": 593,
    //     "defaultCountryOption": { value: "ECU", label: "Ecuador" },
    //     "phoneMask": "+999 99-999-9999"
    // },
    // "GUY": {
    //     "language": "en",
    //     "documentsList": [],
    //     "b2bDocument": null,
    //     "billingAddressList": [
    //         ["billing_address_street1"],
    //         ["billing_address_city", "billing_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "shippingAddressList": [
    //         ["shipping_address_street1"],
    //         ["shipping_address_city", "shipping_address_state"],
    //         ["shipping_address_postal_code_no_mask"]
    //     ],
    //     "countryDial": 592,
    //     "defaultCountryOption": { value: "GUY", label: "Guyana" },
    //     "phoneMask": "+999 999-9999"
    // },
    // "SUR": {
    //     "language": "en",
    //     "documentsList": [],
    //     "b2bDocument": null,
    //     "billingAddressList": [
    //         ["billing_address_street1"],
    //         ["billing_address_city", "billing_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "shippingAddressList": [
    //         ["shipping_address_street1"],
    //         ["shipping_address_city", "shipping_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "countryDial": 597,
    //     "defaultCountryOption": { value: "SUR", label: "Suriname" },
    //     "phoneMask": "+999 999-9999"
    // },
    // "GUF": {
    //     "language": "fr-FR",
    //     "documentsList": [],
    //     "b2bDocument": null,
    //     "billingAddressList": [
    //         ["billing_address_street1"],
    //         ["billing_address_city", "billing_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "shippingAddressList": [
    //         ["shipping_address_street1"],
    //         ["shipping_address_city", "shipping_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "countryDial": 594,
    //     "defaultCountryOption": { value: "GUF", label: "French Guiana" },
    //     "phoneMask": "+999 99999-9999"
    // },
    // "MEX": {
    //     "language": "es-ES",
    //     "documentsList": [],
    //     "b2bDocument": null,
    //     "billingAddressList": [
    //         ["billing_address_street1"],
    //         ["billing_address_city", "billing_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "shippingAddressList": [
    //         ["shipping_address_street1"],
    //         ["shipping_address_city", "shipping_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "countryDial": 52,
    //     "defaultCountryOption": { value: "MEX", label: "México" },
    //     "phoneMask": "+99 (999) 999-9999"
    // },
    // "CAN": {
    //     "language": "en",
    //     "documentsList": [],
    //     "b2bDocument": null,
    //     "billingAddressList": [
    //         ["billing_address_street1"],
    //         ["billing_address_city", "billing_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "shippingAddressList": [
    //         ["shipping_address_street1"],
    //         ["shipping_address_city", "shipping_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "countryDial": 1,
    //     "defaultCountryOption": { value: "CAN", label: "Canada" },
    //     "phoneMask": "+9 (999) 999-9999"
    // },
    // "ESP": {
    //     "language": "es-ES",
    //     "documentsList": [],
    //     "b2bDocument": null,
    //     "billingAddressList": [
    //         ["billing_address_street1"],
    //         ["billing_address_city", "billing_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "shippingAddressList": [
    //         ["shipping_address_street1"],
    //         ["shipping_address_city", "shipping_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "countryDial": 34,
    //     "defaultCountryOption": { value: "ESP", label: "España" },
    //     "phoneMask": "+99 999 999 999"
    // },
    // "PRT": {
    //     "language": "pt-PT",
    //     "documentsList": [],
    //     "b2bDocument": null,
    //     "billingAddressList": [
    //         ["billing_address_street1"],
    //         ["billing_address_city", "billing_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "shippingAddressList": [
    //         ["shipping_address_street1"],
    //         ["shipping_address_city", "shipping_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "countryDial": 351,
    //     "defaultCountryOption": { value: "PRT", label: "Portugal" },
    //     "phoneMask": "+999 999 999 999"
    // },
    // "ITA": {
    //     "language": "it-IT",
    //     "documentsList": [],
    //     "b2bDocument": null,
    //     "billingAddressList": [
    //         ["billing_address_street1"],
    //         ["billing_address_city", "billing_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "shippingAddressList": [
    //         ["shipping_address_street1"],
    //         ["shipping_address_city", "shipping_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "countryDial": 39,
    //     "defaultCountryOption": { value: "ITA", label: "Italia" },
    //     "phoneMask": "+99 999 999 9999"
    // },
    // "DEU": {
    //     "language": "de-DE",
    //     "documentsList": [],
    //     "b2bDocument": null,
    //     "billingAddressList": [
    //         ["billing_address_street1"],
    //         ["billing_address_city", "billing_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "shippingAddressList": [
    //         ["shipping_address_street1"],
    //         ["shipping_address_city", "shipping_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "countryDial": 49,
    //     "defaultCountryOption": { value: "DEU", label: "Deutschland" },
    //     "phoneMask": "+99 9999 9999999"
    // },
    // "GBR": {
    //     "language": "en",
    //     "documentsList": [],
    //     "b2bDocument": null,
    //     "billingAddressList": [
    //         ["billing_address_street1"],
    //         ["billing_address_city", "billing_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "shippingAddressList": [
    //         ["shipping_address_street1"],
    //         ["shipping_address_city", "shipping_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "countryDial": 44,
    //     "defaultCountryOption": { value: "GBR", label: "United Kingdom" },
    //     "phoneMask": "+99 9999 999999"
    // },
    // "CHN": {
    //     "language": "zh-CN",
    //     "documentsList": [],
    //     "b2bDocument": null,
    //     "billingAddressList": [
    //         ["billing_address_street1"],
    //         ["billing_address_city", "billing_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "shippingAddressList": [
    //         ["shipping_address_street1"],
    //         ["shipping_address_city", "shipping_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "countryDial": 86,
    //     "defaultCountryOption": { value: "CHN", label: "中国" },
    //     "phoneMask": "+99 999 9999 9999"
    // },
    // "JPN": {
    //     "language": "ja-JP",
    //     "documentsList": [],
    //     "b2bDocument": null,
    //     "billingAddressList": [
    //         ["billing_address_street1"],
    //         ["billing_address_city", "billing_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "shippingAddressList": [
    //         ["shipping_address_street1"],
    //         ["shipping_address_city", "shipping_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "countryDial": 81,
    //     "defaultCountryOption": { value: "JPN", label: "日本" },
    //     "phoneMask": "+99 99-9999-9999"
    // },
    // "KOR": {
    //     "language": "ko-KR",
    //     "documentsList": [],
    //     "b2bDocument": null,
    //     "billingAddressList": [
    //         ["billing_address_street1"],
    //         ["billing_address_city", "billing_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "shippingAddressList": [
    //         ["shipping_address_street1"],
    //         ["shipping_address_city", "shipping_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "countryDial": 82,
    //     "defaultCountryOption": { value: "KOR", label: "대한민국" },
    //     "phoneMask": "+99 99-9999-9999"
    // },
    // "IND": {
    //     "language": "en",
    //     "documentsList": [],
    //     "b2bDocument": null,
    //     "billingAddressList": [
    //         ["billing_address_street1"],
    //         ["billing_address_city", "billing_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "shippingAddressList": [
    //         ["shipping_address_street1"],
    //         ["shipping_address_city", "shipping_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "countryDial": 91,
    //     "defaultCountryOption": { value: "IND", label: "India" },
    //     "phoneMask": "+99 99999-99999"
    // },
    // "AUS": {
    //     "language": "en",
    //     "documentsList": [],
    //     "b2bDocument": null,
    //     "billingAddressList": [
    //         ["billing_address_street1"],
    //         ["billing_address_city", "billing_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "shippingAddressList": [
    //         ["shipping_address_street1"],
    //         ["shipping_address_city", "shipping_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "countryDial": 61,
    //     "defaultCountryOption": { value: "AUS", label: "Australia" },
    //     "phoneMask": "+99 999 999 999"
    // },
    // "NZL": {
    //     "language": "en",
    //     "documentsList": [],
    //     "b2bDocument": null,
    //     "billingAddressList": [
    //         ["billing_address_street1"],
    //         ["billing_address_city", "billing_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "shippingAddressList": [
    //         ["shipping_address_street1"],
    //         ["shipping_address_city", "shipping_address_state"],
    //         ["billing_address_postal_code_no_mask"]
    //     ],
    //     "countryDial": 64,
    //     "defaultCountryOption": { value: "NZL", label: "New Zealand" },
    //     "phoneMask": "+99 99-999-9999"
    // }
}

export default formSchema
